import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'substring',
  standalone: false,
  pure: true,
})
export class SubstringPipe implements PipeTransform {
  transform(value: string, ...args: [number, number?, string?]) {
    const [start, length, suffix] = args;

    if (!value) {
      return '';
    }

    const maxLength = length || value.length;
    const suffixLength = suffix?.length || 0;
    const end = start + (maxLength - suffixLength);
    const truncated = value.length > maxLength;
    const result = value.substring(start, truncated ? end : undefined);

    return truncated ? result + (suffix || '') : result;
  }
}
